/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Watchpage_TitleInputs */

const en_fw_watchpage_title = /** @type {(inputs: Fw_Watchpage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to watch Firefly Wedding`)
};

const zh_fw_watchpage_title = /** @type {(inputs: Fw_Watchpage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁观看指南`)
};

/**
* | output |
* | --- |
* | "Where to watch Firefly Wedding" |
*
* @param {Fw_Watchpage_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_watchpage_title = /** @type {((inputs?: Fw_Watchpage_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Watchpage_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_watchpage_title(inputs)
	return zh_fw_watchpage_title(inputs)
});
export { fw_watchpage_title as "fw.watchpage.title" }